module.exports = __webpack_public_path__ + "img/wro-2023-elemntry.ce4cd720.png";